import { TextInput } from '@any-ui-react/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { CountrySelectSingle } from '@/common/components/shared/select/country/CountrySelect';
import { CurrencySelectSingle } from '@/common/components/shared/select/currency/CurrencySelect';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmployeePersonalInformationFormDataType } from '@/common/types';

export const ConsultingFeeFormFields = () => {
  const {
    formState: { errors },
    register,
    setValue,
    control,
  } = useFormContext<EmployeePersonalInformationFormDataType>();
  const consultingFeeBankCountryCode = useWatch({ control, name: 'consultingFeeBankCountryCode' });
  const consultingFeeBankCurrencyId = useWatch({ control, name: 'consultingFeeBankCurrencyId' });

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Consulting Fee</div>
      <fieldset className="form-fieldset">
        <CurrencySelectSingle
          className="col-span-2 lg:col-span-1"
          disabled={!isEditable}
          error={errors.consultingFeeBankCurrencyId?.message}
          label="Consulting Fee Currency"
          placeholder="Select the currency to pay"
          value={consultingFeeBankCurrencyId}
          onChange={option => {
            setValue('consultingFeeBankCurrencyId', option?.value as string);
          }}
        />
        <CountrySelectSingle
          className="col-span-2 lg:col-span-1"
          disabled={!isEditable}
          error={errors.consultingFeeBankCountryCode?.message}
          label="Bank Country"
          placeholder="Select Bank Country"
          value={consultingFeeBankCountryCode}
          onChange={option => {
            setValue('consultingFeeBankCountryCode', option?.value as string);
          }}
        />
        <TextInput
          {...register('consultingFeeBankName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Bank Name"
          placeholder="Enter Bank Name"
        />
        <TextInput
          {...register('consultingFeeBranchName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Branch Name"
          placeholder="Enter Branch Name"
        />
        <TextInput
          {...register('consultingFeeAccountNumber')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Account Number"
          placeholder="Enter Account Number"
        />
        <TextInput
          {...register('consultingFeeAccountHolderName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Account Holder Name"
          placeholder="Enter Account Holder Name"
        />
      </fieldset>
    </div>
  );
};
